import { getHeapIds } from './getHeapIds'

/**
 * Accepts the contentful data returned from FETCH_CONTENTFUL_DATA_SUCCESS and
 * the search params used to query contentful and formats the data into a data
 * object to send to Heap to create a custom event.
 *
 * @param {array} careCategories
 * @param {array} careGuide
 * @param {array} commonQuestions
 * @param {string} insuranceProduct
 * @param {array} providerGuide
 * @param {string} ratingArea
 * @param {string} searchTerms
 */
export const addContentfulCareSearchEvent = ({
  careCategories = [],
  careGuide = [],
  commonQuestions = [],
  insuranceProduct = '',
  providerGuide = [],
  ratingArea = '',
  searchTerms = '',
}) => {
  // we can only do any of this if heap is loaded and the searchTerms prop is passed
  if (!window.heap || !searchTerms || !ratingArea) return

  // the params used to query contentful
  const searchParams = {
    insuranceProduct: insuranceProduct,
    ratingArea: ratingArea,
    searchTerms: searchTerms,
  }

  // the data returned from contentful which will be used in the heap charts
  const contentfulData = {
    careCategoriesReturned: careCategories.length > 0,
    careGuideReturned: careGuide.length > 0,
    commonQuestionsReturned: commonQuestions.length > 0,
    commonQuestionCount: commonQuestions.length,
    providerGuideReturned: providerGuide.length > 0,
  }

  // pre-checked provider categories from contentful which do not have a contentful heapId
  const careCategoriesData = {
    careCategories: careCategories.length > 0 ? careCategories.join(', ') : '',
  }

  // the heapIds from the contentful content which will be used in the heap charts
  const commonQuestionsHeapIds = getHeapIds({
    content: commonQuestions,
    key: 'heapIdQuestion',
  })
  const careGuideHeapIds = getHeapIds({
    content: careGuide,
    key: 'heapIdCareGuide',
  })
  const providerGuideHeapIds = getHeapIds({
    content: providerGuide,
    key: 'heapIdProviderGuide',
  })

  // combine the search params, contentful data and heapIds into one object to send to heap
  const heapEventData = {
    ...careCategoriesData,
    ...careGuideHeapIds,
    ...commonQuestionsHeapIds,
    ...contentfulData,
    ...providerGuideHeapIds,
    ...searchParams,
  }

  // Add the custom tracking event but we need to clear the event properties
  // before we do so. We have no way of knowing what those properties are
  // and we don't seem to be setting them anywhere but without this clearing
  // the endpoints will have duplicate properties in them. Do before and
  // after just to be safe.
  window.heap.clearEventProperties()
  window.heap.track('contentfulCareSearchData', heapEventData)
  window.heap.clearEventProperties()
}
